var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M72.276 13.644 13.835 74.192M58.215 76.226c7.365 4.366 16.918 1.2 21.469-6.501 4.55-7.702 2.724-17.614-4.641-21.98-7.366-4.368-16.92-1.201-21.47 6.5-4.55 7.701-2.724 17.614 4.642 21.98ZM15.598 36.12c7.365 4.366 16.918 1.2 21.468-6.502 4.55-7.701 2.725-17.613-4.64-21.98-7.366-4.367-16.92-1.201-21.47 6.5-4.55 7.702-2.724 17.614 4.642 21.981Z"
  })));
};
export default SvgDiscount;